import { useMutation } from "@apollo/client";
import { Button } from "@blueprintjs/core";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { Article, CreateArticleInput } from "../../../api/schema";
import {
  FlexCenter,
  FlexGrow,
  FlexRowStretch,
} from "../../../components/flex/Flex";
import {
  DeleteModal,
  DeleteStateHelper,
} from "../../../components/form/DeleteModal";
import { ValuesVariables } from "../../../components/form/InputForm";
import { Table } from "../../../components/Table";
import { UserLanguage } from "../../../lang/lang";
import {
  ArticleListResponse,
  CreateArticleMutation,
  CreateArticleResponse,
  DeleteArticleMutation,
  DeleteArticleResponse,
} from "../helper/graphql";
import { CreateArticleModal } from "../modals/CreateArticle";
import { ArticleViewTableColumns } from "./table";

interface ArticleListViewProps {
  refetch: () => void;
  data: ArticleListResponse;
}

export const ArticleListView = (props: ArticleListViewProps) => {
  const [create_modal_open, set_create_modal_open] = useState(false);

  const [delete_modal_state, set_delete_modal_state] =
    useState<DeleteStateHelper>({
      open: false,
      id: undefined,
      prettyPrint: undefined,
    });

  const [create_article] = useMutation<
    CreateArticleResponse,
    ValuesVariables<CreateArticleInput>
  >(CreateArticleMutation);

  const [delete_article] = useMutation<DeleteArticleResponse>(
    DeleteArticleMutation
  );

  const history = useHistory();

  return (
    <FlexCenter style={{ padding: "2em" }}>
      <div style={{ width: "100%" }}>
        <FlexRowStretch>
          <div>
            <h2>{UserLanguage().pages.article.list}</h2>
          </div>
          <FlexGrow />
          <div>
            <Button
              intent="success"
              icon="plus"
              onClick={() => set_create_modal_open(true)}
            >
              {UserLanguage().actions.create}
            </Button>
          </div>
        </FlexRowStretch>
        <CreateArticleModal
          bundle={{
            open: create_modal_open,
            onClose: () => set_create_modal_open(false),
            mutation: create_article,
            onSuccess: (data) =>
              history.push("/articles/" + data.createArticle.id),
            article_view_data: props.data,
          }}
        />
        <DeleteModal<DeleteArticleResponse>
          id={delete_modal_state.id}
          open={delete_modal_state.open}
          mutation={(id) => delete_article({ variables: { id } })}
          texts={UserLanguage().pages.article.actions}
          resetOnClose
          onClose={() => {
            set_delete_modal_state({ open: false, id: undefined });
          }}
          onSuccess={() => {
            set_delete_modal_state({ open: false, id: undefined });
            props.refetch();
          }}
          type={UserLanguage().data.article.label}
          prettyPrint={delete_modal_state.prettyPrint}
        />
        <Table<Article>
          columns={ArticleViewTableColumns(set_delete_modal_state)}
          items={props.data.articles}
        />
      </div>
    </FlexCenter>
  );
};
